// Generated C layer lookup table
// Contains flattened taxonomy for Composites

export const C_LAYER_LOOKUP = {
  RMX: {
    numericCode: '001',
    name: 'Music_Video_ReMixes',
  },
  'RMX.POP': {
    numericCode: '001',
    name: 'Pop_ReMixes',
  },
  'RMX.RCK': {
    numericCode: '002',
    name: 'Rock_ReMixes',
  },
  'RMX.HIP': {
    numericCode: '003',
    name: 'Hip_Hop_ReMixes',
  },
  'RMX.EDM': {
    numericCode: '004',
    name: 'EDM_ReMixes',
  },
  'RMX.LAT': {
    numericCode: '005',
    name: 'Latin_ReMixes',
  },
  'RMX.JZZ': {
    numericCode: '006',
    name: 'Jazz_ReMixes',
  },
  SLC: {
    numericCode: '002',
    name: 'Star_Look_Combinations',
  },
  'SLC.POP': {
    numericCode: '001',
    name: 'Pop',
  },
  'SLC.RCK': {
    numericCode: '002',
    name: 'Rock',
  },
  'SLC.HIP': {
    numericCode: '003',
    name: 'Hip_Hop',
  },
  'SLC.JZZ': {
    numericCode: '004',
    name: 'Jazz',
  },
  FUL: {
    numericCode: '003',
    name: 'Full_Composites',
  },
  'FUL.POP': {
    numericCode: '001',
    name: 'Pop',
  },
  'FUL.RCK': {
    numericCode: '002',
    name: 'Rock',
  },
  'FUL.LAT': {
    numericCode: '003',
    name: 'Latin',
  },
  'FUL.AFB': {
    numericCode: '004',
    name: 'Afrobeats',
  },
  CMX: {
    numericCode: '004',
    name: 'CoMix_Projects',
  },
  'CMX.FRG': {
    numericCode: '001',
    name: 'Friend_Groups',
  },
  'CMX.COL': {
    numericCode: '002',
    name: 'Creator_Collabs',
  },
  'CMX.BRD': {
    numericCode: '003',
    name: 'Brand_Partnerships',
  },
  UGC: {
    numericCode: '005',
    name: 'User_Generated',
  },
  'UGC.TRN': {
    numericCode: '001',
    name: 'Trending',
  },
  'UGC.FEA': {
    numericCode: '002',
    name: 'Featured',
  },
  'UGC.STP': {
    numericCode: '003',
    name: 'Staff_Picks',
  },
  'UGC.COM': {
    numericCode: '004',
    name: 'Community_Favorites',
  },
  BRM: {
    numericCode: '006',
    name: 'Branded_ReMixes',
  },
  'BRM.FAS': {
    numericCode: '001',
    name: 'Fashion',
  },
  'BRM.EVT': {
    numericCode: '002',
    name: 'Events',
  },
  'BRM.SPN': {
    numericCode: '003',
    name: 'Sponsorships',
  },
};

export const C_SUBCATEGORIES = {
  RMX: ['RMX.POP', 'RMX.RCK', 'RMX.HIP', 'RMX.EDM', 'RMX.LAT', 'RMX.JZZ'],
  SLC: ['SLC.POP', 'SLC.RCK', 'SLC.HIP', 'SLC.JZZ'],
  FUL: ['FUL.POP', 'FUL.RCK', 'FUL.LAT', 'FUL.AFB'],
  CMX: ['CMX.FRG', 'CMX.COL', 'CMX.BRD'],
  UGC: ['UGC.TRN', 'UGC.FEA', 'UGC.STP', 'UGC.COM'],
  BRM: ['BRM.FAS', 'BRM.EVT', 'BRM.SPN'],
};
